module.exports = __webpack_public_path__ + "img/eyes_male_round_mask.ed1fb6dc.png";